// extracted by mini-css-extract-plugin
module.exports = {"check_box":"Checkbox_check_box__KuoyL","box":"Checkbox_box__RZvQf"};